/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DialogFlowTemplateMessageOption'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./DialogFlowTemplateMessageOption'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogFlowTemplateMessageReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DialogFlowTemplateMessageOption);
  }
}(this, function(ApiClient, DialogFlowTemplateMessageOption) {
  'use strict';




  /**
   * The DialogFlowTemplateMessageReport model module.
   * @module model/DialogFlowTemplateMessageReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DialogFlowTemplateMessageReport</code>.
   * @alias module:model/DialogFlowTemplateMessageReport
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>DialogFlowTemplateMessageReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DialogFlowTemplateMessageReport} obj Optional instance to populate.
   * @return {module:model/DialogFlowTemplateMessageReport} The populated <code>DialogFlowTemplateMessageReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Options')) {
        obj['Options'] = ApiClient.convertToType(data['Options'], [DialogFlowTemplateMessageOption]);
      }
      if (data.hasOwnProperty('FlowTemplateID')) {
        obj['FlowTemplateID'] = ApiClient.convertToType(data['FlowTemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('MessageTypeID')) {
        obj['MessageTypeID'] = ApiClient.convertToType(data['MessageTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('MessageFI')) {
        obj['MessageFI'] = ApiClient.convertToType(data['MessageFI'], 'String');
      }
      if (data.hasOwnProperty('MessageEN')) {
        obj['MessageEN'] = ApiClient.convertToType(data['MessageEN'], 'String');
      }
      if (data.hasOwnProperty('MessageSE')) {
        obj['MessageSE'] = ApiClient.convertToType(data['MessageSE'], 'String');
      }
      if (data.hasOwnProperty('Message')) {
        obj['Message'] = ApiClient.convertToType(data['Message'], 'String');
      }
      if (data.hasOwnProperty('InputMaxLength')) {
        obj['InputMaxLength'] = ApiClient.convertToType(data['InputMaxLength'], 'Integer');
      }
      if (data.hasOwnProperty('InputVariableName')) {
        obj['InputVariableName'] = ApiClient.convertToType(data['InputVariableName'], 'String');
      }
      if (data.hasOwnProperty('ConversionRuleID')) {
        obj['ConversionRuleID'] = ApiClient.convertToType(data['ConversionRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('NextMessageID')) {
        obj['NextMessageID'] = ApiClient.convertToType(data['NextMessageID'], 'Integer');
      }
      if (data.hasOwnProperty('LogicGateValueSourceID')) {
        obj['LogicGateValueSourceID'] = ApiClient.convertToType(data['LogicGateValueSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('MultiOptionDataSourceID')) {
        obj['MultiOptionDataSourceID'] = ApiClient.convertToType(data['MultiOptionDataSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('OpenAiResultCollectionPrompt')) {
        obj['OpenAiResultCollectionPrompt'] = ApiClient.convertToType(data['OpenAiResultCollectionPrompt'], 'String');
      }
      if (data.hasOwnProperty('CustomMessageTitle')) {
        obj['CustomMessageTitle'] = ApiClient.convertToType(data['CustomMessageTitle'], 'String');
      }
      if (data.hasOwnProperty('MaxAnswersCount')) {
        obj['MaxAnswersCount'] = ApiClient.convertToType(data['MaxAnswersCount'], 'Integer');
      }
      if (data.hasOwnProperty('SourceMessageID')) {
        obj['SourceMessageID'] = ApiClient.convertToType(data['SourceMessageID'], 'Integer');
      }
      if (data.hasOwnProperty('TryFilterByStrategy')) {
        obj['TryFilterByStrategy'] = ApiClient.convertToType(data['TryFilterByStrategy'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/DialogFlowTemplateMessageOption>} Options
   */
  exports.prototype['Options'] = undefined;
  /**
   * @member {Integer} FlowTemplateID
   * @default 0
   */
  exports.prototype['FlowTemplateID'] = 0;
  /**
   * @member {Integer} MessageTypeID
   * @default 0
   */
  exports.prototype['MessageTypeID'] = 0;
  /**
   * @member {String} MessageFI
   * @default ''
   */
  exports.prototype['MessageFI'] = '';
  /**
   * @member {String} MessageEN
   * @default ''
   */
  exports.prototype['MessageEN'] = '';
  /**
   * @member {String} MessageSE
   * @default ''
   */
  exports.prototype['MessageSE'] = '';
  /**
   * @member {String} Message
   * @default ''
   */
  exports.prototype['Message'] = '';
  /**
   * @member {Integer} InputMaxLength
   * @default 0
   */
  exports.prototype['InputMaxLength'] = 0;
  /**
   * @member {String} InputVariableName
   * @default ''
   */
  exports.prototype['InputVariableName'] = '';
  /**
   * @member {Integer} ConversionRuleID
   * @default 0
   */
  exports.prototype['ConversionRuleID'] = 0;
  /**
   * @member {Integer} NextMessageID
   */
  exports.prototype['NextMessageID'] = undefined;
  /**
   * @member {Integer} LogicGateValueSourceID
   */
  exports.prototype['LogicGateValueSourceID'] = undefined;
  /**
   * @member {Integer} MultiOptionDataSourceID
   */
  exports.prototype['MultiOptionDataSourceID'] = undefined;
  /**
   * @member {String} OpenAiResultCollectionPrompt
   * @default ''
   */
  exports.prototype['OpenAiResultCollectionPrompt'] = '';
  /**
   * @member {String} CustomMessageTitle
   * @default ''
   */
  exports.prototype['CustomMessageTitle'] = '';
  /**
   * @member {Integer} MaxAnswersCount
   * @default 0
   */
  exports.prototype['MaxAnswersCount'] = 0;
  /**
   * @member {Integer} SourceMessageID
   */
  exports.prototype['SourceMessageID'] = undefined;
  /**
   * @member {Boolean} TryFilterByStrategy
   * @default false
   */
  exports.prototype['TryFilterByStrategy'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


